module.exports = __webpack_public_path__ + "static/multidisciplinar-233d58624decb5f51a6cefa7eff08ed3.svg";